import {
  observer,
  useTranslation,
  Modal,
  Link,
  Button,
} from "../vendor/api.js";
// Recovered from static/main.7bd2eca3bac83dc8.chunk.js, module 24597, offsets 1158:138599. Structure and names inferred from code, not screenshots.
import { module32314 as d } from "../vendor/dependencies.js";
import * as PlatformModule from "../config/platform.js";
import * as AnalyticsContext from "../analytics/AnalyticsProvider.jsx";
import * as EnvironmentModule from "../config/environment.js";
import * as React from "react";
import * as jsxRuntime from "react/jsx-runtime";
function InviteLogo({ className: className, fill: t = "#1F2329" }) {
  return (
    <svg
      className={className}
      width={"132"}
      height={"16"}
      viewBox={"0 0 132 16"}
      fill={"none"}
      xmlns={"http://www.w3.org/2000/svg"}
    >
      <g>
        <path
          d={
            "M64.9008 0.00138769C64.6875 -0.00400695 64.4753 0.0339904 64.2771 0.113075C64.0789 0.192159 63.8988 0.310682 63.7478 0.461454C63.5968 0.612226 63.478 0.792105 63.3985 0.990178C63.3191 1.18825 63.2808 1.40039 63.2858 1.61373C63.2858 2.04553 63.4574 2.45964 63.7627 2.76497C64.068 3.0703 64.4821 3.24183 64.9139 3.24183C65.3457 3.24183 65.7599 3.0703 66.0652 2.76497C66.3705 2.45964 66.542 2.04553 66.542 1.61373C66.5473 1.39811 66.5082 1.18371 66.4271 0.983812C66.3461 0.783917 66.2249 0.602783 66.0711 0.451629C65.9172 0.300476 65.734 0.182523 65.5327 0.105076C65.3314 0.027629 65.1163 -0.00766247 64.9008 0.00138769Z"
          }
          fill={t}
        />
        <path
          d={"M66.1689 4.55469H63.6296V15.7255H66.1689V4.55469Z"}
          fill={t}
        />
        <path
          d={
            "M38.8643 4.06641C35.3586 4.06641 33.0872 6.76065 33.0872 10.0326C33.0872 13.3045 35.3717 16.0014 38.8643 16.0014C42.3568 16.0014 44.6414 13.3072 44.6414 10.0326C44.6414 6.75802 42.3673 4.06641 38.8643 4.06641ZM38.8643 13.6932C37.0261 13.6932 35.5844 12.3408 35.5844 10.0326C35.5844 7.72437 37.0261 6.37463 38.8643 6.37463C40.7025 6.37463 42.1415 7.727 42.1415 10.0326C42.1415 12.3382 40.7025 13.6932 38.8643 13.6932Z"
          }
          fill={t}
        />
        <path
          d={
            "M17.7909 0.000890693C17.5765 -0.00632181 17.3629 0.0303305 17.1631 0.108601C16.9634 0.186872 16.7817 0.305111 16.6293 0.456073C16.4768 0.607034 16.3568 0.787536 16.2766 0.986515C16.1964 1.18549 16.1577 1.39876 16.1628 1.61323C16.1628 2.04503 16.3343 2.45914 16.6397 2.76447C16.945 3.0698 17.3591 3.24133 17.7909 3.24133C18.2227 3.24133 18.6368 3.0698 18.9421 2.76447C19.2475 2.45914 19.419 2.04503 19.419 1.61323C19.4241 1.39876 19.3854 1.18549 19.3052 0.986515C19.225 0.787536 19.105 0.607034 18.9525 0.456073C18.8001 0.305111 18.6184 0.186872 18.4187 0.108601C18.2189 0.0303305 18.0053 -0.00632181 17.7909 0.000890693Z"
          }
          fill={t}
        />
        <path
          d={
            "M11.7564 15.7252L0.359741 1.61328H3.51615L15.1124 15.7252H11.7564Z"
          }
          fill={t}
        />
        <path
          d={"M3.35861 15.7252L14.7527 1.61328H11.5963L0 15.7252H3.35861Z"}
          fill={t}
        />
        <path
          d={"M19.0618 4.55469H16.5225V15.7255H19.0618V4.55469Z"}
          fill={t}
        />
        <path
          d={
            "M26.5905 3.78906C24.5055 3.78906 23.0454 4.31426 21.7009 5.36464L22.6988 7.20282C23.6328 6.41651 24.8055 5.96948 26.0259 5.93448C27.7354 5.93448 28.7543 6.82993 28.7543 8.38975H26.8347C23.0139 8.38975 20.9184 10.2699 21.1442 12.8539C21.4068 15.921 24.6158 16.005 24.9808 16.005C26.5563 16.005 28.0321 15.4799 28.7543 14.5214V15.7188H31.2936V8.37662C31.2936 7.12404 30.7001 3.78906 26.5905 3.78906ZM28.7543 11.1418C28.7231 11.8658 28.4128 12.5496 27.8885 13.05C27.3642 13.5503 26.6666 13.8282 25.9419 13.8255C24.7392 13.8255 23.9304 13.2504 23.8411 12.3366C23.7518 11.4227 24.5921 10.2831 27.5174 10.2831H28.7569L28.7543 11.1418Z"
          }
          fill={t}
        />
        <path
          d={
            "M57.7238 4.11087C57.0499 4.09158 56.3837 4.25893 55.7989 4.59444C55.2141 4.92994 54.7334 5.42054 54.4099 6.01207C53.7954 4.64394 52.7923 4.11087 51.6868 4.11087C51.1688 4.13165 50.6626 4.2713 50.2072 4.51901C49.7519 4.76672 49.3596 5.11585 49.0608 5.5394V4.55203H46.5215V15.7255H49.0608V9.11859C49.0608 8.25464 49.0608 6.40071 50.8044 6.40071C52.5481 6.40071 52.5481 8.25465 52.5481 8.72732V15.7255H55.0139V8.72732C55.0139 8.25465 55.0139 6.40071 56.7575 6.40071C58.5011 6.40071 58.5038 8.25464 58.5038 9.11859V15.7255H61.0404V8.4017C61.0536 5.3976 59.6093 4.11087 57.7238 4.11087Z"
          }
          fill={t}
        />
        <path
          d={
            "M73.7449 15.9987C73.4083 15.998 73.0857 15.8638 72.8479 15.6256C72.6101 15.3873 72.4766 15.0644 72.4766 14.7278V7.165C72.4914 6.83757 72.632 6.52848 72.869 6.30203C73.1059 6.07559 73.4211 5.94922 73.7488 5.94922C74.0766 5.94922 74.3918 6.07559 74.6287 6.30203C74.8657 6.52848 75.0062 6.83757 75.0211 7.165V14.7278C75.0208 14.895 74.9875 15.0606 74.9232 15.215C74.8588 15.3693 74.7647 15.5095 74.6462 15.6276C74.5277 15.7456 74.3871 15.8391 74.2325 15.9028C74.0778 15.9665 73.9122 15.9991 73.7449 15.9987Z"
          }
          fill={t}
        />
        <path
          d={
            "M87.3607 15.9993C87.0234 15.9993 86.6998 15.8655 86.4611 15.6272C86.2223 15.389 86.0878 15.0657 86.0871 14.7284V4.67881L81.4654 9.45281C81.2304 9.69657 80.9081 9.83697 80.5695 9.84312C80.231 9.84928 79.9038 9.72069 79.6601 9.48563C79.4163 9.25058 79.2759 8.92832 79.2697 8.58976C79.2667 8.42211 79.2967 8.25551 79.358 8.09947C79.4194 7.94342 79.5108 7.80098 79.6272 7.68028L86.4469 0.661082C86.6229 0.478921 86.8494 0.35354 87.0973 0.301033C87.3451 0.248526 87.603 0.271291 87.8378 0.366403C88.0727 0.461516 88.2737 0.624637 88.4151 0.834827C88.5566 1.04502 88.632 1.29268 88.6317 1.54603V14.7284C88.6317 15.0655 88.4978 15.3887 88.2594 15.6271C88.021 15.8654 87.6978 15.9993 87.3607 15.9993Z"
          }
          fill={t}
        />
        <path
          d={
            "M80.5514 9.82621C80.3824 9.82749 80.2149 9.79518 80.0584 9.73117C79.902 9.66716 79.7599 9.57272 79.6402 9.45332L72.8337 2.4315C72.599 2.18948 72.4701 1.86414 72.4752 1.52705C72.4804 1.18996 72.6193 0.868726 72.8613 0.634023C73.1033 0.399319 73.4287 0.270369 73.7658 0.27554C74.1028 0.280711 74.4241 0.419579 74.6588 0.661595L81.4653 7.66767C81.6389 7.84735 81.7558 8.07413 81.8015 8.31977C81.8472 8.56541 81.8196 8.81906 81.7222 9.04914C81.6248 9.27922 81.4618 9.47557 81.2537 9.61374C81.0455 9.75191 80.8013 9.8258 80.5514 9.82621Z"
          }
          fill={t}
        />
        <path
          d={
            "M98.3029 15.9992C97.9659 15.9992 97.6426 15.8653 97.4042 15.627C97.1659 15.3886 97.032 15.0654 97.032 14.7283V7.1655C97.032 6.82842 97.1659 6.50514 97.4042 6.26679C97.6426 6.02844 97.9659 5.89453 98.3029 5.89453C98.64 5.89453 98.9633 6.02844 99.2017 6.26679C99.44 6.50514 99.5739 6.82842 99.5739 7.1655V14.7283C99.5739 15.0654 99.44 15.3886 99.2017 15.627C98.9633 15.8653 98.64 15.9992 98.3029 15.9992Z"
          }
          fill={t}
        />
        <path
          d={
            "M111.916 16.0004C111.579 16.0004 111.256 15.8664 111.017 15.6281C110.779 15.3897 110.645 15.0665 110.645 14.7294V4.67982L106.023 9.45382C105.788 9.69584 105.467 9.83457 105.129 9.83949C104.792 9.84442 104.466 9.71513 104.224 9.48008C103.982 9.24503 103.844 8.92346 103.839 8.58613C103.834 8.24879 103.963 7.92331 104.198 7.6813L111.005 0.662093C111.181 0.483575 111.407 0.361405 111.653 0.311007C111.899 0.260609 112.155 0.284243 112.387 0.378925C112.62 0.473608 112.819 0.635093 112.96 0.842994C113.101 1.05089 113.177 1.29589 113.179 1.54704V14.7294C113.178 15.0649 113.045 15.3866 112.809 15.6246C112.572 15.8625 112.251 15.9976 111.916 16.0004Z"
          }
          fill={t}
        />
        <path
          d={
            "M105.109 9.82618C104.94 9.82746 104.773 9.79516 104.616 9.73115C104.46 9.66713 104.318 9.57269 104.198 9.45329L97.3917 2.43147C97.2687 2.31326 97.1708 2.1715 97.1037 2.01463C97.0367 1.85777 97.0019 1.68901 97.0015 1.51842C97.001 1.34783 97.0349 1.1789 97.1012 1.02169C97.1674 0.864476 97.2646 0.722207 97.387 0.603357C97.5093 0.484507 97.6544 0.391509 97.8135 0.329905C97.9725 0.268302 98.1424 0.239353 98.3129 0.244785C98.4834 0.250217 98.6511 0.289918 98.8059 0.361522C98.9607 0.433126 99.0996 0.535168 99.2141 0.661566L106.023 7.66764C106.197 7.84732 106.314 8.0741 106.359 8.31974C106.405 8.56538 106.378 8.81903 106.28 9.04911C106.183 9.27919 106.02 9.47554 105.812 9.61371C105.603 9.75189 105.359 9.82577 105.109 9.82618Z"
          }
          fill={t}
        />
        <path
          d={
            "M92.8305 15.9997C92.4935 15.9997 92.1702 15.8658 91.9318 15.6274C91.6935 15.3891 91.5596 15.0658 91.5596 14.7287V1.54636C91.5596 1.20928 91.6935 0.886001 91.9318 0.647648C92.1702 0.409296 92.4935 0.275391 92.8305 0.275391C93.1676 0.275391 93.4909 0.409296 93.7292 0.647648C93.9676 0.886001 94.1015 1.20928 94.1015 1.54636V14.7287C94.1015 14.8956 94.0686 15.0609 94.0048 15.2151C93.9409 15.3693 93.8473 15.5094 93.7292 15.6274C93.6112 15.7454 93.4711 15.839 93.3169 15.9029C93.1627 15.9668 92.9974 15.9997 92.8305 15.9997Z"
          }
          fill={t}
        />
        <path
          d={
            "M123.42 15.9814C122.03 15.9865 120.663 15.6287 119.454 14.9433C118.244 14.2579 117.235 13.2687 116.525 12.0735C115.815 10.8783 115.43 9.5185 115.407 8.12863C115.384 6.73875 115.724 5.36692 116.393 4.1488C116.561 3.86356 116.833 3.65487 117.152 3.56707C117.471 3.47927 117.811 3.51928 118.101 3.67859C118.391 3.8379 118.608 4.10397 118.704 4.42026C118.801 4.73656 118.771 5.07816 118.62 5.3725C118.053 6.40664 117.836 7.59693 118.003 8.76468C118.169 9.93243 118.71 11.0147 119.544 11.8489C120.378 12.6831 121.46 13.2244 122.628 13.3914C123.795 13.5584 124.986 13.3421 126.02 12.7751C126.315 12.6125 126.663 12.5738 126.987 12.6676C127.311 12.7614 127.584 12.98 127.747 13.2753C127.909 13.5706 127.948 13.9184 127.854 14.2422C127.76 14.566 127.542 14.8393 127.246 15.0019C126.074 15.6455 124.758 15.9824 123.42 15.9814Z"
          }
          fill={t}
        />
        <path
          d={
            "M129.287 12.5052C129.071 12.5044 128.86 12.4484 128.672 12.3424C128.378 12.1795 128.159 11.9066 128.066 11.5833C127.972 11.26 128.009 10.9126 128.171 10.6171C128.738 9.58297 128.955 8.39268 128.788 7.22493C128.622 6.05718 128.081 4.97496 127.247 4.14073C126.413 3.30649 125.331 2.76525 124.163 2.59825C122.996 2.43125 121.805 2.64749 120.771 3.21452C120.624 3.30059 120.462 3.3564 120.293 3.37863C120.125 3.40087 119.954 3.38908 119.79 3.34397C119.626 3.29886 119.473 3.22134 119.339 3.116C119.206 3.01066 119.095 2.87964 119.013 2.73069C118.931 2.58174 118.88 2.41788 118.863 2.24882C118.845 2.07975 118.862 1.90891 118.912 1.7464C118.962 1.58389 119.044 1.43301 119.153 1.3027C119.262 1.17238 119.396 1.06527 119.547 0.987704C121.064 0.155491 122.809 -0.162266 124.522 0.0821474C126.234 0.326561 127.822 1.11995 129.045 2.34319C130.268 3.56642 131.061 5.15347 131.306 6.86604C131.55 8.5786 131.232 10.3242 130.4 11.8408C130.291 12.0411 130.13 12.2084 129.934 12.3253C129.739 12.4422 129.515 12.5043 129.287 12.5052Z"
          }
          fill={t}
        />
      </g>
    </svg>
  );
}
function InviteModalHeader({ onClose: onClose }) {
  return (
    <div className={"flex items-center justify-between py-[18px]"}>
      <div className={"h-[22px]"}>
        <InviteLogo className={"w-full h-full"} fill={"#1F2329"} />
      </div>
      <button
        type={"button"}
        onClick={onClose}
        className={
          "size-[22px] flex items-center justify-center text-[#000] cursor-pointer"
        }
      >
        <d.A
          style={{
            fontSize: 16,
          }}
        />
      </button>
    </div>
  );
}
let CheckIcon = () => (
  <svg
    width={"16"}
    height={"16"}
    viewBox={"0 0 24 24"}
    fill={"none"}
    xmlns={"http://www.w3.org/2000/svg"}
  >
    <path
      d={
        "M16.0032 9.41421L7.39663 18.0208L5.98242 16.6066L14.589 8H7.00324V6H18.0032V17H16.0032V9.41421Z"
      }
      fill={"currentColor"}
    />
  </svg>
);
let InviteCodeModal = observer(() => {
  let e,
    {
      showInviteCodeModal: showInviteCodeModal,
      closeInviteCodeModal: closeInviteCodeModal,
    } = PlatformModule.inviteStore,
    { track: track } = (0, AnalyticsContext.useAnalytics)(),
    { t: translate, i18n: i18n } = useTranslation(),
    l = (0, EnvironmentModule.y)();
  (0, React.useEffect)(() => {
    showInviteCodeModal &&
      track("track", "invite_modal_show", {
        trigger_source: "entry_click",
        inviter_reward: 10,
        invitee_reward: 10,
      });
  }, [showInviteCodeModal, track]);
  let s =
      "en" === i18n.language
        ? (() => {
            let e = Number.parseFloat("0.9");
            if (Number.isNaN(e) || e < 0 || e > 1) return "";
            let t = Math.round((1 - e) * 100);
            return `${t}%`;
          })()
        : Number.isNaN((e = Number.parseFloat("0.9"))) || e < 0 || e > 1
          ? 0
          : Math.round((Math.round(100 * e) / 10) * 10) / 10,
    c = l
      ? [
          `${translate("invite.createModal.benefit1", {
            symbol: "¥",
            amount: 10,
          })} \xb7 ${translate("invite.createModal.benefit1Tag", {
            amount: 30,
          })}`,
          `${translate("invite.createModal.benefit2", {
            inviteeDiscountRate: s,
            rate: "10%",
          })} \xb7 ${translate("invite.createModal.benefit2Tag")}`,
        ]
      : [
          translate("invite.createModal.benefit1NoRegister", {
            inviteeDiscountRate: s,
          }),
          translate("invite.createModal.benefit2NoRegister", {
            rate: "10%",
          }),
        ];
  return (
    <Modal
      className={"invite-modal"}
      open={showInviteCodeModal}
      onCancel={closeInviteCodeModal}
      width={"en" === i18n.language ? 614 : 560}
      centered={true}
      footer={null}
      closable={false}
      zIndex={1001}
      styles={{
        content: {
          padding: 0,
          borderRadius: 24,
          overflow: "hidden",
          background: "linear-gradient(to bottom, #fff8f1, #ffffff)",
        },
        mask: {
          backdropFilter: "blur(4px)",
        },
      }}
      wrapClassName={"invite-code-modal-responsive"}
    >
      <div className={"flex flex-col"}>
        <div className={"flex flex-col pt-[24px] px-[16px] md:px-[24px]"}>
          <InviteModalHeader onClose={closeInviteCodeModal} />
          <div className={"flex flex-col gap-[12px] w-full"}>
            <div className={"flex flex-col gap-[16px] w-full"}>
              <div
                className={
                  "text-[17px] md:text-[32px] font-[600] text-[#040000] leading-[36px] md:leading-[52px]"
                }
              >
                <p className={"m-0"}>
                  {translate("invite.createModal.titleLine1")}
                </p>
                <p className={"m-0"}>
                  {translate("invite.createModal.titleLine2")}
                </p>
              </div>
              <div className={"flex flex-col w-full"}>
                {l ? (
                  <jsxRuntime.Fragment>
                    <div className={"flex h-[36px] items-center"}>
                      <div
                        className={
                          "bg-black flex gap-[10px] items-center h-full px-[8px]"
                        }
                      >
                        <span
                          className={
                            "text-white text-[16px] font-medium tracking-[1px] whitespace-nowrap leading-[16px]"
                          }
                        >
                          {translate("invite.createModal.banner", {
                            symbol: "¥",
                            amount: 10,
                            rate: "10%",
                          })}
                        </span>
                      </div>
                    </div>
                    <div className={"flex h-[36px] items-center"}>
                      <div
                        className={
                          "flex bg-[#f9ede0] items-center h-full px-[8px]"
                        }
                      >
                        <span
                          className={
                            "text-[#303030] text-[12px] md:text-[14px] font-medium leading-[16px] whitespace-nowrap"
                          }
                        >
                          {translate("invite.createModal.kolSubBanner", {
                            inviteeDiscountRate: s,
                            rate: "10%",
                          })}
                        </span>
                      </div>
                    </div>
                  </jsxRuntime.Fragment>
                ) : (
                  <div className={"flex h-[36px] items-center"}>
                    <div
                      className={
                        "bg-black flex gap-[10px] items-center h-full px-[8px]"
                      }
                    >
                      <span
                        className={
                          "text-white text-[16px] font-medium tracking-[1px] whitespace-nowrap leading-[16px]"
                        }
                      >
                        {translate("invite.createModal.bannerNoRegister", {
                          inviteeDiscountRate: s,
                          rate: "10%",
                        })}
                      </span>
                    </div>
                  </div>
                )}
              </div>
              <div className={"flex flex-col w-full"}>
                {c.map((e) => (
                  <div key={e} className={"flex gap-[4px] items-start"}>
                    <div
                      className={
                        "flex min-h-[24px] items-center justify-center py-[2px]"
                      }
                    >
                      <span
                        className={
                          "text-[12px] md:text-[14px] font-medium leading-[24px]"
                        }
                      >
                        {e}
                      </span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className={"flex gap-[24px]"}>
              <Link
                to={"/docs/promotions/refer"}
                target={"_blank"}
                rel={"noopener noreferrer"}
                className={
                  "group flex items-center gap-[4px] text-[14px] text-[#000] tracking-[2px] leading-[24px] hover:text-[#9E4F0A] transition-colors no-underline w-max"
                }
              >
                {translate("invite.createModal.rulesLink")}
                <span
                  className={"group-hover:text-[#9E4F0A] transition-colors"}
                >
                  <CheckIcon />
                </span>
              </Link>
            </div>
          </div>
        </div>
        <div
          className={"w-full overflow-hidden"}
          style={{
            height: 32,
          }}
        >
          <svg
            preserveAspectRatio={"none"}
            width={"100%"}
            height={"100%"}
            viewBox={"0 0 589 32"}
            fill={"none"}
            xmlns={"http://www.w3.org/2000/svg"}
          >
            <path
              d={"M0 16H589"}
              stroke={"#96928B"}
              strokeWidth={"0.5"}
              strokeDasharray={"2 2"}
            />
          </svg>
        </div>
        <div className={"flex px-[16px] md:px-[24px] pt-[16px] pb-[24px]"}>
          <Button
            type={"primary"}
            onClick={() => {
              window.open(
                "https://platform.xiaomimimo.com/console/balance?from=home",
              );
            }}
            className={
              "!w-full !h-[44px] !rounded-none !border-none !bg-black !text-[#f6f3ec] !text-[12px] !font-normal !tracking-[2.4px] flex items-center justify-center gap-[12px]"
            }
            style={{
              boxShadow: "none",
            }}
          >
            {translate("invite.createModal.loginButtonText")}
            <svg
              width={"14"}
              height={"14"}
              viewBox={"0 0 14 14"}
              fill={"none"}
              className={"shrink-0"}
            >
              <path
                d={"M1 7h12M8 2l5 5-5 5"}
                stroke={"#f6f3ec"}
                strokeWidth={"1.5"}
                strokeLinecap={"round"}
                strokeLinejoin={"round"}
              />
            </svg>
          </Button>
        </div>
      </div>
    </Modal>
  );
});
export { InviteLogo, InviteModalHeader, CheckIcon, InviteCodeModal };
